"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Composite = _interopRequireDefault(require("../renderer/Composite.js"));

var _Control = _interopRequireDefault(require("./Control.js"));

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _MapEventType = _interopRequireDefault(require("../MapEventType.js"));

var _MapProperty = _interopRequireDefault(require("../MapProperty.js"));

var _ObjectEventType = _interopRequireDefault(require("../ObjectEventType.js"));

var _Overlay = _interopRequireDefault(require("../Overlay.js"));

var _OverlayPositioning = _interopRequireDefault(require("../OverlayPositioning.js"));

var _PluggableMap = _interopRequireDefault(require("../PluggableMap.js"));

var _View = _interopRequireDefault(require("../View.js"));

var _ViewProperty = _interopRequireDefault(require("../ViewProperty.js"));

var _css = require("../css.js");

var _extent = require("../extent.js");

var _events = require("../events.js");

var _Polygon = require("../geom/Polygon.js");

var _dom = require("../dom.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/control/OverviewMap
 */


/**
 * Maximum width and/or height extent ratio that determines when the overview
 * map should be zoomed out.
 * @type {number}
 */
var MAX_RATIO = 0.75;
/**
 * Minimum width and/or height extent ratio that determines when the overview
 * map should be zoomed in.
 * @type {number}
 */

var MIN_RATIO = 0.1;

var ControlledMap =
/** @class */
function (_super) {
  __extends(ControlledMap, _super);

  function ControlledMap() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ControlledMap.prototype.createRenderer = function () {
    return new _Composite["default"](this);
  };

  return ControlledMap;
}(_PluggableMap["default"]);
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-overviewmap'] CSS class name.
 * @property {boolean} [collapsed=true] Whether the control should start collapsed or not (expanded).
 * @property {string|HTMLElement} [collapseLabel='‹'] Text label to use for the
 * expanded overviewmap button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {boolean} [collapsible=true] Whether the control can be collapsed or not.
 * @property {string|HTMLElement} [label='›'] Text label to use for the collapsed
 * overviewmap button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {Array<import("../layer/Base.js").default>|import("../Collection.js").default<import("../layer/Base.js").default>} [layers]
 * Layers for the overview map.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control
 * should be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {boolean} [rotateWithView=false] Whether the control view should rotate with the main map view.
 * @property {HTMLElement|string} [target] Specify a target if you want the control
 * to be rendered outside of the map's viewport.
 * @property {string} [tipLabel='Overview map'] Text label to use for the button tip.
 * @property {View} [view] Custom view for the overview map (should use same projection as main map). If not provided,
 * a default view with the same projection as the main map will be used.
 */

/**
 * Create a new control with a map acting as an overview map for another
 * defined map.
 *
 * @api
 */


var OverviewMap =
/** @class */
function (_super) {
  __extends(OverviewMap, _super);
  /**
   * @param {Options} [opt_options] OverviewMap options.
   */


  function OverviewMap(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    _this = _super.call(this, {
      element: document.createElement('div'),
      render: options.render,
      target: options.target
    }) || this;
    /**
     * @private
     */

    _this.boundHandleRotationChanged_ = _this.handleRotationChanged_.bind(_this);
    /**
     * @type {boolean}
     * @private
     */

    _this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
    /**
     * @private
     * @type {boolean}
     */

    _this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;

    if (!_this.collapsible_) {
      _this.collapsed_ = false;
    }
    /**
     * @private
     * @type {boolean}
     */


    _this.rotateWithView_ = options.rotateWithView !== undefined ? options.rotateWithView : false;
    /**
     * @private
     * @type {import("../extent.js").Extent|undefined}
     */

    _this.viewExtent_ = undefined;
    var className = options.className !== undefined ? options.className : 'ol-overviewmap';
    var tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Overview map';
    var collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : "\u2039";

    if (typeof collapseLabel === 'string') {
      /**
       * @private
       * @type {HTMLElement}
       */
      _this.collapseLabel_ = document.createElement('span');
      _this.collapseLabel_.textContent = collapseLabel;
    } else {
      _this.collapseLabel_ = collapseLabel;
    }

    var label = options.label !== undefined ? options.label : "\u203A";

    if (typeof label === 'string') {
      /**
       * @private
       * @type {HTMLElement}
       */
      _this.label_ = document.createElement('span');
      _this.label_.textContent = label;
    } else {
      _this.label_ = label;
    }

    var activeLabel = _this.collapsible_ && !_this.collapsed_ ? _this.collapseLabel_ : _this.label_;
    var button = document.createElement('button');
    button.setAttribute('type', 'button');
    button.title = tipLabel;
    button.appendChild(activeLabel);
    button.addEventListener(_EventType["default"].CLICK, _this.handleClick_.bind(_this), false);
    /**
     * @type {HTMLElement}
     * @private
     */

    _this.ovmapDiv_ = document.createElement('div');
    _this.ovmapDiv_.className = 'ol-overviewmap-map';
    /**
     * Explicitly given view to be used instead of a view derived from the main map.
     * @type {View}
     * @private
     */

    _this.view_ = options.view;
    /**
     * @type {ControlledMap}
     * @private
     */

    _this.ovmap_ = new ControlledMap({
      view: options.view
    });
    var ovmap = _this.ovmap_;

    if (options.layers) {
      options.layers.forEach(function (layer) {
        ovmap.addLayer(layer);
      });
    }

    var box = document.createElement('div');
    box.className = 'ol-overviewmap-box';
    box.style.boxSizing = 'border-box';
    /**
     * @type {import("../Overlay.js").default}
     * @private
     */

    _this.boxOverlay_ = new _Overlay["default"]({
      position: [0, 0],
      positioning: _OverlayPositioning["default"].CENTER_CENTER,
      element: box
    });

    _this.ovmap_.addOverlay(_this.boxOverlay_);

    var cssClasses = className + ' ' + _css.CLASS_UNSELECTABLE + ' ' + _css.CLASS_CONTROL + (_this.collapsed_ && _this.collapsible_ ? ' ' + _css.CLASS_COLLAPSED : '') + (_this.collapsible_ ? '' : ' ol-uncollapsible');
    var element = _this.element;
    element.className = cssClasses;
    element.appendChild(_this.ovmapDiv_);
    element.appendChild(button);
    /* Interactive map */

    var scope = _this;
    var overlay = _this.boxOverlay_;

    var overlayBox = _this.boxOverlay_.getElement();
    /* Functions definition */


    var computeDesiredMousePosition = function computeDesiredMousePosition(mousePosition) {
      return {
        clientX: mousePosition.clientX,
        clientY: mousePosition.clientY
      };
    };

    var move = function move(event) {
      var position =
      /** @type {?} */
      computeDesiredMousePosition(event);
      var coordinates = ovmap.getEventCoordinateInternal(
      /** @type {MouseEvent} */
      position);
      overlay.setPosition(coordinates);
    };

    var endMoving = function endMoving(event) {
      var coordinates = ovmap.getEventCoordinateInternal(event);
      scope.getMap().getView().setCenterInternal(coordinates);
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', endMoving);
    };
    /* Binding */


    overlayBox.addEventListener('mousedown', function () {
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', endMoving);
    });
    return _this;
  }
  /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../PluggableMap.js").default|null} map Map.
   * @api
   */


  OverviewMap.prototype.setMap = function (map) {
    var oldMap = this.getMap();

    if (map === oldMap) {
      return;
    }

    if (oldMap) {
      var oldView = oldMap.getView();

      if (oldView) {
        this.unbindView_(oldView);
      }

      this.ovmap_.setTarget(null);
    }

    _super.prototype.setMap.call(this, map);

    if (map) {
      this.ovmap_.setTarget(this.ovmapDiv_);
      this.listenerKeys.push((0, _events.listen)(map, _ObjectEventType["default"].PROPERTYCHANGE, this.handleMapPropertyChange_, this));
      var view = map.getView();

      if (view) {
        this.bindView_(view);

        if (view.isDef()) {
          this.ovmap_.updateSize();
          this.resetExtent_();
        }
      }

      if (!this.ovmap_.isRendered()) {
        this.updateBoxAfterOvmapIsRendered_();
      }
    }
  };
  /**
   * Handle map property changes.  This only deals with changes to the map's view.
   * @param {import("../Object.js").ObjectEvent} event The propertychange event.
   * @private
   */


  OverviewMap.prototype.handleMapPropertyChange_ = function (event) {
    if (event.key === _MapProperty["default"].VIEW) {
      var oldView =
      /** @type {import("../View.js").default} */
      event.oldValue;

      if (oldView) {
        this.unbindView_(oldView);
      }

      var newView = this.getMap().getView();
      this.bindView_(newView);
    } else if (!this.ovmap_.isRendered() && (event.key === _MapProperty["default"].TARGET || event.key === _MapProperty["default"].SIZE)) {
      this.ovmap_.updateSize();
    }
  };
  /**
   * Register listeners for view property changes.
   * @param {import("../View.js").default} view The view.
   * @private
   */


  OverviewMap.prototype.bindView_ = function (view) {
    if (!this.view_) {
      // Unless an explicit view definition was given, derive default from whatever main map uses.
      var newView = new _View["default"]({
        projection: view.getProjection()
      });
      this.ovmap_.setView(newView);
    }

    view.addChangeListener(_ViewProperty["default"].ROTATION, this.boundHandleRotationChanged_); // Sync once with the new view

    this.handleRotationChanged_();
  };
  /**
   * Unregister listeners for view property changes.
   * @param {import("../View.js").default} view The view.
   * @private
   */


  OverviewMap.prototype.unbindView_ = function (view) {
    view.removeChangeListener(_ViewProperty["default"].ROTATION, this.boundHandleRotationChanged_);
  };
  /**
   * Handle rotation changes to the main map.
   * @private
   */


  OverviewMap.prototype.handleRotationChanged_ = function () {
    if (this.rotateWithView_) {
      this.ovmap_.getView().setRotation(this.getMap().getView().getRotation());
    }
  };
  /**
   * Reset the overview map extent if the box size (width or
   * height) is less than the size of the overview map size times minRatio
   * or is greater than the size of the overview size times maxRatio.
   *
   * If the map extent was not reset, the box size can fits in the defined
   * ratio sizes. This method then checks if is contained inside the overview
   * map current extent. If not, recenter the overview map to the current
   * main map center location.
   * @private
   */


  OverviewMap.prototype.validateExtent_ = function () {
    var map = this.getMap();
    var ovmap = this.ovmap_;

    if (!map.isRendered() || !ovmap.isRendered()) {
      return;
    }

    var mapSize =
    /** @type {import("../size.js").Size} */
    map.getSize();
    var view = map.getView();
    var extent = view.calculateExtentInternal(mapSize);

    if (this.viewExtent_ && (0, _extent.equals)(extent, this.viewExtent_)) {
      // repeats of the same extent may indicate constraint conflicts leading to an endless cycle
      return;
    }

    this.viewExtent_ = extent;
    var ovmapSize =
    /** @type {import("../size.js").Size} */
    ovmap.getSize();
    var ovview = ovmap.getView();
    var ovextent = ovview.calculateExtentInternal(ovmapSize);
    var topLeftPixel = ovmap.getPixelFromCoordinateInternal((0, _extent.getTopLeft)(extent));
    var bottomRightPixel = ovmap.getPixelFromCoordinateInternal((0, _extent.getBottomRight)(extent));
    var boxWidth = Math.abs(topLeftPixel[0] - bottomRightPixel[0]);
    var boxHeight = Math.abs(topLeftPixel[1] - bottomRightPixel[1]);
    var ovmapWidth = ovmapSize[0];
    var ovmapHeight = ovmapSize[1];

    if (boxWidth < ovmapWidth * MIN_RATIO || boxHeight < ovmapHeight * MIN_RATIO || boxWidth > ovmapWidth * MAX_RATIO || boxHeight > ovmapHeight * MAX_RATIO) {
      this.resetExtent_();
    } else if (!(0, _extent.containsExtent)(ovextent, extent)) {
      this.recenter_();
    }
  };
  /**
   * Reset the overview map extent to half calculated min and max ratio times
   * the extent of the main map.
   * @private
   */


  OverviewMap.prototype.resetExtent_ = function () {
    if (MAX_RATIO === 0 || MIN_RATIO === 0) {
      return;
    }

    var map = this.getMap();
    var ovmap = this.ovmap_;
    var mapSize =
    /** @type {import("../size.js").Size} */
    map.getSize();
    var view = map.getView();
    var extent = view.calculateExtentInternal(mapSize);
    var ovview = ovmap.getView(); // get how many times the current map overview could hold different
    // box sizes using the min and max ratio, pick the step in the middle used
    // to calculate the extent from the main map to set it to the overview map,

    var steps = Math.log(MAX_RATIO / MIN_RATIO) / Math.LN2;
    var ratio = 1 / (Math.pow(2, steps / 2) * MIN_RATIO);
    (0, _extent.scaleFromCenter)(extent, ratio);
    ovview.fitInternal((0, _Polygon.fromExtent)(extent));
  };
  /**
   * Set the center of the overview map to the map center without changing its
   * resolution.
   * @private
   */


  OverviewMap.prototype.recenter_ = function () {
    var map = this.getMap();
    var ovmap = this.ovmap_;
    var view = map.getView();
    var ovview = ovmap.getView();
    ovview.setCenterInternal(view.getCenterInternal());
  };
  /**
   * Update the box using the main map extent
   * @private
   */


  OverviewMap.prototype.updateBox_ = function () {
    var map = this.getMap();
    var ovmap = this.ovmap_;

    if (!map.isRendered() || !ovmap.isRendered()) {
      return;
    }

    var mapSize =
    /** @type {import("../size.js").Size} */
    map.getSize();
    var view = map.getView();
    var ovview = ovmap.getView();
    var rotation = this.rotateWithView_ ? 0 : -view.getRotation();
    var overlay = this.boxOverlay_;
    var box = this.boxOverlay_.getElement();
    var center = view.getCenterInternal();
    var resolution = view.getResolution();
    var ovresolution = ovview.getResolution();
    var width = mapSize[0] * resolution / ovresolution;
    var height = mapSize[1] * resolution / ovresolution; // set position using center coordinates

    overlay.setPosition(center); // set box size calculated from map extent size and overview map resolution

    if (box) {
      box.style.width = width + 'px';
      box.style.height = height + 'px';
      var transform = 'rotate(' + rotation + 'rad)';
      box.style.transform = transform;
    }
  };
  /**
   * @private
   */


  OverviewMap.prototype.updateBoxAfterOvmapIsRendered_ = function () {
    if (this.ovmapPostrenderKey_) {
      return;
    }

    this.ovmapPostrenderKey_ = (0, _events.listenOnce)(this.ovmap_, _MapEventType["default"].POSTRENDER, function (event) {
      delete this.ovmapPostrenderKey_;
      this.updateBox_();
    }, this);
  };
  /**
   * @param {MouseEvent} event The event to handle
   * @private
   */


  OverviewMap.prototype.handleClick_ = function (event) {
    event.preventDefault();
    this.handleToggle_();
  };
  /**
   * @private
   */


  OverviewMap.prototype.handleToggle_ = function () {
    this.element.classList.toggle(_css.CLASS_COLLAPSED);

    if (this.collapsed_) {
      (0, _dom.replaceNode)(this.collapseLabel_, this.label_);
    } else {
      (0, _dom.replaceNode)(this.label_, this.collapseLabel_);
    }

    this.collapsed_ = !this.collapsed_; // manage overview map if it had not been rendered before and control
    // is expanded

    var ovmap = this.ovmap_;

    if (!this.collapsed_) {
      if (ovmap.isRendered()) {
        this.viewExtent_ = undefined;
        ovmap.render();
        return;
      }

      ovmap.updateSize();
      this.resetExtent_();
      this.updateBoxAfterOvmapIsRendered_();
    }
  };
  /**
   * Return `true` if the overview map is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */


  OverviewMap.prototype.getCollapsible = function () {
    return this.collapsible_;
  };
  /**
   * Set whether the overview map should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */


  OverviewMap.prototype.setCollapsible = function (collapsible) {
    if (this.collapsible_ === collapsible) {
      return;
    }

    this.collapsible_ = collapsible;
    this.element.classList.toggle('ol-uncollapsible');

    if (!collapsible && this.collapsed_) {
      this.handleToggle_();
    }
  };
  /**
   * Collapse or expand the overview map according to the passed parameter. Will
   * not do anything if the overview map isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */


  OverviewMap.prototype.setCollapsed = function (collapsed) {
    if (!this.collapsible_ || this.collapsed_ === collapsed) {
      return;
    }

    this.handleToggle_();
  };
  /**
   * Determine if the overview map is collapsed.
   * @return {boolean} The overview map is collapsed.
   * @api
   */


  OverviewMap.prototype.getCollapsed = function () {
    return this.collapsed_;
  };
  /**
   * Return `true` if the overview map view can rotate, `false` otherwise.
   * @return {boolean} True if the control view can rotate.
   * @api
   */


  OverviewMap.prototype.getRotateWithView = function () {
    return this.rotateWithView_;
  };
  /**
   * Set whether the overview map view should rotate with the main map view.
   * @param {boolean} rotateWithView True if the control view should rotate.
   * @api
   */


  OverviewMap.prototype.setRotateWithView = function (rotateWithView) {
    if (this.rotateWithView_ === rotateWithView) {
      return;
    }

    this.rotateWithView_ = rotateWithView;

    if (this.getMap().getView().getRotation() !== 0) {
      if (this.rotateWithView_) {
        this.handleRotationChanged_();
      } else {
        this.ovmap_.getView().setRotation(0);
      }

      this.viewExtent_ = undefined;
      this.validateExtent_();
      this.updateBox_();
    }
  };
  /**
   * Return the overview map.
   * @return {import("../PluggableMap.js").default} Overview map.
   * @api
   */


  OverviewMap.prototype.getOverviewMap = function () {
    return this.ovmap_;
  };
  /**
   * Update the overview map element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */


  OverviewMap.prototype.render = function (mapEvent) {
    this.validateExtent_();
    this.updateBox_();
  };

  return OverviewMap;
}(_Control["default"]);

var _default = OverviewMap;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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